import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { ApptSummaryConfigModel } from '../models/appt_summary_config_model';
import { HandRaiseConfigModel } from '../models/hand_raise_config_model';
import { NotesConfigModel } from '../models/notes_config_model';
import { ProgressReportsConfigModel } from '../models/progress_reports_config_model';
import { ReportConfigsQuery } from '../queries/report_configs_query';

export class ReportConfigService {
  constructor(
    private loadApptSummaryConfigsCommand: ICommand,
    private ngApptSummaryConfigModel: ApptSummaryConfigModel,
    private loadHandRaiseConfigsCommand: ICommand,
    private ngHandRaiseConfigModel: HandRaiseConfigModel,
    private loadNotesConfigsCommand: ICommand,
    private ngNotesConfigModel: NotesConfigModel,
    private loadProgressReportsConfigsCommand: ICommand,
    private ngProgressReportsConfigModel: ProgressReportsConfigModel,
    private ngReportConfigsQuery: ReportConfigsQuery
  ) {}

  async getReportConfigs() {
    if (_4.isEmpty(this.ngApptSummaryConfigModel.read().name)) {
      await this.loadApptSummaryConfigsCommand();
    }
    if (_4.isEmpty(this.ngHandRaiseConfigModel.read().name)) {
      await this.loadHandRaiseConfigsCommand();
    }
    if (_4.isEmpty(this.ngNotesConfigModel.read().name)) {
      await this.loadNotesConfigsCommand();
    }
    if (_4.isEmpty(this.ngProgressReportsConfigModel.read().name)) {
      await this.loadProgressReportsConfigsCommand();
    }
    return this.ngReportConfigsQuery.result;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/data-ng-custom-text/src/services/report_config_service.ts